export default {
  system: {
    name: 'Management System',
    language: 'Language',
    theme: 'Theme'
  },
  auth: {
    login: 'Sign In',
    adminPanel: 'Admin Panel',
    phone: 'Phone number',
    password: 'Password',
    signIn: 'Sign In',
    logout: 'Logout',
    confirmLogout: 'Confirm Logout',
    confirmLogoutText: 'Are you sure you want to log out?',
    loginError: 'Login failed. Please check your email and password.',
    forgotPassword: 'If you don\'t know how to login or forgot your password,',
    contactSupport: 'please contact Lockerbot company at:'
  },
  dashboard: {
    title: 'Dashboard',
    user: 'User',
    goodMorning: 'Good morning',
    goodAfternoon: 'Good afternoon',
    goodEvening: 'Good evening',
    welcomeMessage: 'Welcome to the LockerBot Admin Panel. Here you can manage packages, users, and settings.',
    profile: 'My Profile',
    profileTitle: 'User Profile',
    viewAllActive: 'View all active',
    viewAllExpired: 'View all expired packages',
    viewAllFinished: 'View all completed packages',
    totalUsers: 'Total Users',
    totalPackages: 'Total Packages',
    activePackages: 'Active Packages',
    deliveredToday: 'Delivered Today',
    totalCells: 'Total Cells',
    cellsUsage: 'Cells Occupied',
    averageDailyUsage: 'Average Daily Usage',
    cellsUsageChart: 'Cells Usage Chart',
    recentPackages: 'Recent Packages',
    activeUsers: 'Active Users',
    lastActive: 'Last Active',
    lockedPackages: 'Locked Packages',
    expiredPackages: 'Expired',
    finishedPackages: 'Completed',
    currentlyStored: 'Currently in storage',
    storageExpired: 'Storage time expired',
    successfullyDelivered: 'Successfully delivered',
    users: 'Users',
    lockersStatus: 'Lockers Status',
    totalLockers: 'Total Lockers',
    onlineLockers: 'Online',
    offlineLockers: 'Offline',
    maintenanceLockers: 'Maintenance',
    errorLockers: 'Error',
    cellsStatus: 'Cells Status',
    activeCells: 'Active',
    brokenCells: 'Broken',
    occupiedCells: 'Occupied',
    reservedCells: 'Reserved',
    occupancyChart: 'Cells Occupancy History',
    periodSelector: {
      last30Days: 'Last 30 days',
      last60Days: 'Last 60 days',
      last90Days: 'Last 90 days'
    },
    viewAll: 'View all',
    occupancy: 'Locker Occupancy',
    occupancyDescription: 'Current locker usage statistics',
    usageHistory: 'Usage History',
    usageHistoryDescription: 'Package activity over time',
    period: 'Period',
    days7: '7 days',
    days30: '30 days',
    days90: '90 days'
  },
  menu: {
    users: 'Users',
    packages: 'Packages',
    settings: 'Settings'
  },
  users: {
    title: 'Users',
    add: 'Add User',
    confirmDelete: 'Confirm Deletion',
    confirmDeleteText: 'Are you sure you want to delete this user?',
    createSuccess: 'User successfully created',
    createError: 'Failed to create user',
    phoneExists: 'User with this phone number already exists',
    deleteSuccess: 'User successfully deleted',
    deleteError: 'Failed to delete user',
    communities: 'Communities',
    search: 'Search by name',
    communityFilter: 'Filter by community',
    statusFilter: 'Filter by status',
    createTitle: 'Create User',
    editTitle: 'Edit User',
    email: 'Email',
    phone: 'Phone',
    fullName: 'Full Name',
    firstName: 'First Name',
    lastName: 'Last Name',
    password: 'Password',
    passwordHint: 'Leave empty to keep unchanged',
    role: 'Role',
    status: 'Status',
    coinBalance: 'Coin Balance',
    isActive: 'Active user',
    dateJoined: 'Registration Date',
    actions: 'Actions',
    edit: 'Edit',
    delete: 'Delete',
    statuses: {
      active: 'Active',
      inactive: 'Inactive'
    },
    topupBalance: 'Top Up Balance',
    topupFor: 'Top up balance for',
    coinsAmount: 'Coins Amount',
    topupSuccess: 'Balance successfully topped up',
    topupError: 'Failed to top up balance'
  },
  packages: {
    title: 'Packages',
    add: 'Add',
    search: 'Search',
    statusFilter: 'Status Filter',
    typeFilter: 'Type Filter',
    id: 'ID',
    device: 'Device',
    cell: 'Cell',
    sender: 'Sender',
    recipient: 'Recipient',
    type: 'Type',
    status: 'Status',
    details: 'Details',
    detailsTitle: 'Package Details',
    createdAt: 'Created At',
    expiresAt: 'Expires At',
    price: 'Price',
    courier: 'Courier',
    basicInfo: 'Basic Information',
    contactInfo: 'Contact Information',
    locationInfo: 'Location Information',
    phone: 'Phone',
    community: 'Community',
    notFound: 'Package Not Found',
    notFoundText: 'The package you are looking for does not exist or has been removed.',
    backToList: 'Back to Packages List',
    actions: 'Actions',
    allCommunities: 'All Communities',
    statuses: {
      all: 'All Statuses',
      new: 'New',
      locked: 'Locked',
      finished: 'Finished',
      canceled: 'Canceled',
      expired: 'Expired'
    },
    types: {
      delivery: 'Delivery',
      storage: 'Storage',
      shared: 'Shared'
    },
    eventsHistory: 'Events History',
    eventTypes: {
      cell_was_opened: 'Cell was opened',
      cell_was_closed: 'Cell was closed',
      parcel_created: 'Parcel created',
      parcel_updated: 'Parcel updated',
      parcel_expired: 'Parcel expired',
      parcel_finished: 'Parcel finished',
      parcel_canceled: 'Parcel canceled',
      cell_photo_was_received: 'Photo'
    },
    statusAll: 'All',
    statusLocked: 'Active',
    statusExpired: 'Expired',
    statusFinished: 'Completed',
    dateFilter: 'Filter by creation date',
    startDateFilter: 'From date',
    endDateFilter: 'To date'
  },
  settings: {
    title: 'Settings',
    profileInfo: 'Profile Information',
    appSettings: 'Application Settings',
    email: 'Email',
    fullName: 'Full Name',
    notSpecified: 'Not specified',
    role: 'Role',
    language: 'System Language',
    dateJoined: 'Registration Date',
    theme: 'Theme',
    roles: {
      administrator: 'Administrator',
      manager: 'Manager',
      customer: 'Customer'
    },
    notifications: {
      email: 'Email Notifications',
      sms: 'SMS Notifications'
    },
    save: 'Save Settings',
    tariffs: 'Tariffs',
    noTariffsData: 'Tariff information is not available',
    freeMinutes: 'Free time',
    pricePerHour: 'Price per hour',
    pricePerDay: 'Price per day',
    minutes: 'minutes',
    currency: '₽',
    communities: 'Communities',
    communitySettings: 'Community Settings',
    confirmSaveTitle: 'Confirm Changes',
    confirmSaveText: 'Are you sure you want to save these changes?',
    noCommunities: 'No communities available',
    selectCommunity: 'Select Community',
    generalSection: 'General Settings',
    limitsSection: 'Limits Settings',
    pricingSection: 'Pricing Settings',
    communityName: 'Community Name',
    communityAddress: 'Address',
    autoApproveUsers: 'Auto-approve Users',
    maxCellsPerCustomer: 'Maximum Cells per Customer',
    maxCellsPerCustomerHint: 'Maximum number of cells allowed per customer',
    maxDeliveryHours: 'Maximum Delivery Hours',
    maxDeliveryHoursHint: 'Maximum hours for delivery storage',
    maxStorageHours: 'Maximum Storage Hours',
    maxStorageHoursHint: 'Maximum hours for cell rental',
    minStorageHours: 'Minimum Storage Hours',
    minStorageHoursHint: 'Minimum hours for cell rental',
    maxSharingHours: 'Maximum Sharing Hours',
    maxSharingHoursHint: 'Maximum hours allowed for cell sharing',
    deliveryHourlyPrice: 'Delivery Hourly Price',
    deliveryHourlyPriceHint: 'Price per hour for delivery storage',
    storageHourlyPrice: 'Storage Hourly Price',
    storageHourlyPriceHint: 'Price per hour for cell rental',
    sharingHourlyPrice: 'Sharing Hourly Price',
    sharingHourlyPriceHint: 'Price per hour for cell sharing',
    freeDeliveryHours: 'Free Delivery Hours',
    freeDeliveryHoursHint: 'Number of free hours for incoming deliveries',
    freeStorageHours: 'Free Storage Hours',
    freeStorageHoursHint: 'Number of free storage hours',
    freeSharingHours: 'Free Sharing Hours',
    freeSharingHoursHint: 'Number of free sharing hours',
    priceBySlot: 'Price by Slot',
    priceBySlotHint: 'Price is set per individual slot',
  },
  common: {
    cancel: 'Cancel',
    confirm: 'Confirm',
    create: 'Create',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    filter: 'Filter',
    reset: 'Reset',
    loading: 'Loading...',
    noData: 'No data available',
    unknownUser: 'Unknown User',
    copied: '{field} copied to clipboard',
    copyError: 'Failed to copy to clipboard',
    close: 'Close',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Information',
    ok: 'OK',
    total: 'Total',
    pagination: {
      showing: "Showing",
      of: "of",
      perPage: "per page"
    }
  },
  validation: {
    required: 'This field is required',
    phone: 'Enter number in international format',
    minLength: 'Minimum length: {min} characters',
    maxLength: 'Maximum length: {max} characters',
    minValue: 'Minimum value: {min}',
    maxValue: 'Maximum value: {max}'
  },
  locker: {
    title: 'Community Locker',
    slogan: 'Easily drop off, pick up, or share parcels with your community. No lines, no hassle — just simple, secure delivery at your fingertips.',
    downloadTitle: 'Download Our App',
    appStore: 'Download on App Store',
    googlePlay: 'Get it on Google Play',
    copyright: '© 2025. All rights reserved.'
  },
  pickup: {
    title: 'Package Pickup',
    description: 'Scan the QR code below to pick up your package from the locker.',
    code: 'Package Code',
    qrCodeAlt: 'QR Code for package pickup',
    generating: 'Generating QR code...',
    download: 'Download QR Code'
  }
} 